import * as React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { JotFormBlock } from '../../blocksState'
import { JotformBlockLayout } from './jotform.layout'
import { JotFormsBlockState } from './jotform.state'

export const jotFormsBlockWidget = (block: JotFormBlock): Widget<Updater<JotFormsBlockState>> =>
  fromJSX((setState) => (
    <JotformBlockLayout.Block {...block}>
    <JotformBlockLayout.Inner>
      <JotformBlockLayout.Content
        label={block.label}
        title={block.title}
        intro={block.intro}
      >
        <JotformIFrame 
          loadIframe={() => setState((state) => ({ ...state, loaded: true }))} 
          formID={block.formID} 
          formTitle={block.formTitle} 
        />
      </JotformBlockLayout.Content>
    </JotformBlockLayout.Inner>
    </JotformBlockLayout.Block>
  ))

const JotformIFrame = (props: { loadIframe: () => void, formID: string, formTitle?: string }) => {
  const iFrameUrl = createIframeUrl(props.formID);
  return <iframe
    id={`JotFormIFrame-${props.formID}`}
    title={props.formTitle}
    src={iFrameUrl}
    style={{ 'minWidth': '100%', 'height': '539px', 'border': 'none' }}
    scrolling="no">
  </iframe>
}

const createIframeUrl = (formId: string) => {
  const iFrameUrl = new URL(`https://form.jotform.com/${formId}`);
  const urlParams = new URLSearchParams(window.location.search)
  const iFrameParams = new URLSearchParams(iFrameUrl.search)
  console.table([urlParams.toString(), iFrameParams.toString()])

  urlParams.forEach((value, name) => {
    if (!iFrameParams.has(name)) {
      iFrameParams.append(name, value)
    }
  })

  iFrameParams.append("isIframeEmbed", "1");
  const newParams = iFrameParams.toString()
  return iFrameUrl.href + "?" + newParams;
}
